// helper function to get google maps API key
function getGoogleMapsApiKey() {
  if (typeof window.LDCData !== "undefined" && window.LDCData.googleMapsApiKey) {
    return window.LDCData.googleMapsApiKey;
  }
  return 'AIzaSyDeEDZbE6N919ik89YNAO28e7QYu1VspdU';
}
// and also for the reCAPTCHA key
function getRecaptchaSiteKey() {
  if (typeof window.LDCData !== "undefined" && window.LDCData.recaptchaSiteKey) {
    return window.LDCData.recaptchaSiteKey;
  }
  return '';
}

// configurable API url from the command line
export const MARKETING_API_URL = process.env.MARKETING_API_URL || '';

// configurable API url from the command line
export const PORTAL_API_URL = process.env.PORTAL_API_URL || '';

// Vue.js template delimiters since handlebars uses mustache
export const delimiters = ['{[{', '}]}'];

// Google API Key
// @todo replace this value with a production-ready API key.
export const googleMapsApiKeyForLDCs = getGoogleMapsApiKey();

// Google reCAPTCHA site key
export const recaptchaKeys = getRecaptchaSiteKey();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/constants/index.js